import { Outlet } from "react-router-dom";
import PortalNotificationBanner from "../components/notifications/components/PortalNotificationBanner";

export default function NotificationLayout() {
  return (
    <>
      <PortalNotificationBanner />
      <Outlet />
    </>
  );
}
